import React, { FC } from 'react'

import { Button, Input, Text } from '@plurall/elo-beta'

import { USERNAME_MAX_LENGTH } from '../../utils'

import styles from './Form.module.scss'
import useLogin from '../../hooks/useLogin'

const Form: FC = () => {
  const {
    handleSubmit,
    phoneMask,
    onUserNameChange,
    isSubmitting,
    onPasswordChange,
    recoverPasswordLink,
    isOauthLogin,
    onUsernameBlur,
    onLoginWithOauthClick,
    username,
    isCheckingOauth,
    goBackToLogin,
    inputErrors,
    oauthContent,
  } = useLogin()

  return (
    <form className={styles['form-login']} onSubmit={handleSubmit}>
      <Input
        cancelTabIndex='-1'
        id='username'
        name='username'
        type='text'
        maskRegex={phoneMask}
        maxLength={USERNAME_MAX_LENGTH}
        onChange={onUserNameChange}
        dataTestId='input-username'
        label='Nome de usuário, e-mail ou celular'
        variant={inputErrors?.username ? 'negative' : undefined}
        disabled={isSubmitting || isCheckingOauth}
        validation={{
          validationText: 'Campo obrigatório. Digite seu login.',
        }}
        value={username}
        onBlur={onUsernameBlur}
      />
      {isOauthLogin ? (
        <div className={styles['oauth-container']}>
          <Text variant='accent' size='t3'>
            {oauthContent?.description}
          </Text>

          <div className={styles['oauth-button']}>
            <div className={styles['elo-custom-button']}>
              <Button
                size='medium'
                type='button'
                dataTestId='oauth-back-button'
                minimal
                disabled={isSubmitting}
                onClick={goBackToLogin}
              >
                Voltar
              </Button>
            </div>

            <Button
              size='medium'
              type='button'
              dataTestId='login-google'
              loading={isSubmitting}
              onClick={onLoginWithOauthClick}
            >
              {oauthContent?.submit}
            </Button>
          </div>
        </div>
      ) : (
        <>
          <Input
            id='password'
            name='password'
            type='password'
            onChange={onPasswordChange}
            dataTestId='input-password'
            label='Insira a sua senha'
            variant={inputErrors?.password ? 'negative' : undefined}
            disabled={isSubmitting}
            validation={{
              validationText: 'Campo obrigatório. Digite sua senha.',
            }}
            hintText=' '
            hint={{
              linkText: 'Esqueci minha senha',
              link: recoverPasswordLink,
              dataTestId: 'link-recover-password',
            }}
          />

          <Button
            fullWidth
            size='medium'
            type='submit'
            dataTestId='btn-submit'
            loading={isSubmitting}
            disabled={isSubmitting || isCheckingOauth}
          >
            Entrar
          </Button>
        </>
      )}
    </form>
  )
}

export default Form
